import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import CONSTANTS from "src/utils/constants";


let awsRumInstance: AwsRum | null = null;

type Stage = 'Dev' | 'alpha' | 'beta' | 'gamma' | 'preprod' | 'prod';

interface StageConfig {
    applicationId: string;
}

const STAGE_CONFIG: Record<Stage, StageConfig> = {
    Dev: {
        applicationId: '02c465f9-d464-4da4-b3e2-a058a46833a6'
    },
    alpha: {
        applicationId: 'e1753a99-5e5f-430a-969a-5a6f93961465'
    },
    beta: {
        applicationId: '02c465f9-d464-4da4-b3e2-a058a46833a6'
    },
    gamma: {
        applicationId: 'dc0e09b4-5802-4a69-8e8d-ad9e31562fd7'
    },
    preprod: {
        applicationId: '26fce955-521f-4563-92ca-4d0bd9b68afe'
    },
    prod: {
        applicationId: '24b0f163-f78b-4a85-b239-d125c8488942'
    }
};

export function initializeAwsRum(awsCredentials?: any) {
    if (awsRumInstance) {
        console.log('AWS RUM is already initialized');
        return awsRumInstance;
    }
    const region = CONSTANTS.ENVIRONMENT_VARIABLES.AWS_REGION ?? 'us-east-1';
    try {
        const config: AwsRumConfig = {
            sessionSampleRate: 1,
            endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
            telemetries: ["performance","errors","http"],
            allowCookies: true,
            enableXRay: false,
            signing: true
        };
        const stage = CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE.toString();
        console.log(stage);
        const APPLICATION_ID: string = STAGE_CONFIG[stage as Stage].applicationId
        const APPLICATION_VERSION: string = '1.0.0';
        const APPLICATION_REGION: string = CONSTANTS.ENVIRONMENT_VARIABLES.AWS_REGION;

        awsRumInstance = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );

        if (awsCredentials) {
            awsRumInstance.setAwsCredentials({
                accessKeyId: awsCredentials.accessKeyId,
                secretAccessKey: awsCredentials.secretAccessKey,
                sessionToken: awsCredentials.sessionToken
            });
        }
        return awsRumInstance;

    } catch (error) {
        console.error('Error initializing AWS RUM:', error);
        return null;
    }
}